import { RefreshCw, Send } from "lucide-react";

const fmt = (iso) => new Date(iso).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const BudgetStatus = ({ at, outdated, onOpen, testId = "budget-status" }) => {
  if (!at) return null;
  if (outdated) {
    return (
      <div data-testid={testId} className="flex flex-wrap items-center gap-2">
        <span className="rounded-md border border-red-500/50 bg-red-500/15 px-2 py-0.5 text-xs font-semibold text-red-400">Orçamento desatualizado</span>
        {onOpen && (
          <button data-testid={`${testId}-update-btn`} onClick={(e) => { e.stopPropagation(); onOpen(); }}
            className="inline-flex items-center gap-1 rounded-md bg-red-600 px-2 py-1 text-xs font-semibold text-white hover:bg-red-700">
            <RefreshCw className="h-3 w-3" /> Atualizar Orçamento (incluir alterações)
          </button>
        )}
      </div>
    );
  }
  return (
    <div data-testid={testId} className="flex flex-wrap items-center gap-2">
      <span className="rounded-md border border-[#10B981]/50 bg-[#10B981]/15 px-2 py-0.5 text-xs font-semibold text-[#10B981]">Orçamento enviado · {fmt(at)}</span>
      {onOpen && (
        <button data-testid={`${testId}-resend-btn`} onClick={(e) => { e.stopPropagation(); onOpen(); }}
          className="inline-flex items-center gap-1 rounded-md border border-[#10B981]/50 px-2 py-1 text-xs font-semibold text-[#10B981] hover:bg-[#10B981]/10">
          <Send className="h-3 w-3" /> Reenviar Orçamento
        </button>
      )}
    </div>
  );
};
